<template>
  <div>
    <h4 class="page-title">서식모음</h4>

    <template-list />
  </div>
</template>
<script>
  import TemplateList from "@/components/announcement/notice/TemplateList";
  import {dispatch} from "@/core/dispatcher";
  import LoadAnnouncementJob from "@/core/jobs/announcement/LoadAnnouncementJob";

  export default {
    components: {
      TemplateList
    },
    mounted() {
      dispatch(new LoadAnnouncementJob(0, 'template'));
    }
  }
</script>
